import { render, staticRenderFns } from "./ChartjsBarChartProcess.vue?vue&type=template&id=a3af014e&"
import script from "./ChartjsBarChartProcess.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChartProcess.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsBarChartProcess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports